import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { StorageKeys } from '../models/storage-keys';

@Injectable({ providedIn: 'root' })
export class TokenService {
  static token: string;

  constructor() {
    new LocalStorageService().getKey(StorageKeys.token).subscribe((value) => {
      if (value) {
        TokenService.token = value;
      }
    });
  }
}
